export default __webpack_public_path__ + "static/media/emptyListIcon.4f30eab2.svg";